import { SidebarIcon, type SidebarIconProps } from "./sidebar-icon";

export const SidebarRightClosedIcon = (props: SidebarIconProps) => (
  <SidebarIcon side="right" open={false} {...props} />
);
